import { Box, Button, Flex, Form, Icon, Input, Link } from '@cowsquare/design';
import { themeGet } from '@styled-system/theme-get';
import React from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import styled from 'styled-components';
import { color, space, typography } from 'styled-system';
import { Logo } from '../../layouts/Logo';
import { imageSwitch } from '../ResponsiveImage';

const Wrapper = styled(Box).attrs({
  p: 4,
})`
  background-color: ${themeGet('colors.whites.0')};
  width: 720px;
  height: 480px;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 ${themeGet('colors.blacks.8')};
`;

const LogoWrapper = styled(Box).attrs({
  p: 4,
})`
  position: absolute;
`;

const FormWrapper = styled(Flex).attrs({
  p: [6, 7],
})`
  background-color: ${themeGet('colors.whites.0')};
`;

const InfoBoxWrapper = styled(Box)`
  border-radius: 4px;
  background-image: url(${imageSwitch('img_login.png')});
`;

const InfoBoxButton = styled(Box)`
  background-color: ${themeGet('colors.whites.0')};
  padding: 10px 16px;
  border-radius: 8px;
  border: 1px solid ${themeGet('colors.primary')};
  cursor: pointer;
`;

const Text = styled.h3.attrs({
  py: 4,
})`
  margin: 0;
  font-weight: 500;
  letter-spacing: normal;
  color: ${themeGet('colors.whites.0')};
  ${space}
  ${color}
  ${typography}
`;

const ErrorMessage = styled(Box).attrs({
  p: 4,
})`
  color: ${themeGet('colors.danger')};
`;

const Validator = {
  required: value => !value,
};

export const DesktopLoginForm = ({ onSubmit, errorMessage, onSignupClick, onForgetPasswordClick }) => {
  return (
    <Wrapper>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <Flex height="100%">
        <FormWrapper flex="1" flexDirection="column" justifyContent="center">
          <Text mb={5} fontSize="24px" color="black">
            登入
          </Text>
          <FinalForm
            onSubmit={onSubmit}
            render={({ handleSubmit, submitting }) => (
              <>
                <Form>
                  <Field name="email" validate={Validator.required}>
                    {({ input, meta }) => (
                      <Form.FormItem input={input} meta={meta}>
                        <Input
                          {...input}
                          placeholder="請輸入您的電子郵件帳號"
                          prefix={<Icon name="email" />}
                          size="large"
                          type="email"
                        />
                      </Form.FormItem>
                    )}
                  </Field>
                  <Field name="password" validate={Validator.required}>
                    {({ input, meta }) => (
                      <Form.FormItem input={input} meta={meta}>
                        <Input
                          {...input}
                          placeholder="請輸入您的密碼"
                          prefix={<Icon name="password" />}
                          size="large"
                          type="password"
                        />
                      </Form.FormItem>
                    )}
                  </Field>
                </Form>
                <ErrorMessage>{errorMessage}</ErrorMessage>
                <Flex justifyContent="flex-end" alignItems="center">
                  <Button mr={5} variant="link" onClick={onForgetPasswordClick}>
                    忘記密碼？
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    disabled={submitting}
                    type="submit"
                    variant="primary"
                    size="large"
                  >
                    登入
                  </Button>
                </Flex>
              </>
            )}
          />
        </FormWrapper>
        <InfoBoxWrapper>
          <Flex
            width="280px"
            height="100%"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Text fontSize="36px">Let’s Go!</Text>
            <Text fontSize="16px" lineHeight="2.25">
              跟著我們一起體驗精彩旅程吧！
            </Text>
            <Text fontSize="16px" lineHeight="1.69">
              還沒有帳號嗎？
            </Text>
            <Box mt={5}>
              <InfoBoxButton onClick={onSignupClick}>
                <Link>點我註冊</Link>
              </InfoBoxButton>
            </Box>
          </Flex>
        </InfoBoxWrapper>
      </Flex>
    </Wrapper>
  );
};

export const MobileLoginForm = ({ onSubmit, errorMessage = '', onSignupClick, onForgetPasswordClick }) => {
  return (
    <FormWrapper flexDirection="column" flex="1">
      <Text mb={5} fontSize="24px" color="black">
        登入
      </Text>
      <FinalForm
        onSubmit={onSubmit}
        render={({ handleSubmit, submitting }) => (
          <>
            <Form>
              <Field name="email" validate={Validator.required}>
                {({ input, meta }) => (
                  <Form.FormItem input={input} meta={meta}>
                    <Input
                      {...input}
                      placeholder="請輸入您的電子郵件帳號"
                      prefix={<Icon name="email" />}
                      size="large"
                      type="email"
                    />
                  </Form.FormItem>
                )}
              </Field>
              <Field name="password" validate={Validator.required}>
                {({ input, meta }) => (
                  <Form.FormItem input={input} meta={meta}>
                    <Input
                      {...input}
                      placeholder="請輸入您的密碼"
                      prefix={<Icon name="password" />}
                      size="large"
                      type="password"
                    />
                  </Form.FormItem>
                )}
              </Field>
            </Form>
            <ErrorMessage>{errorMessage}</ErrorMessage>
            <Flex justifyContent="flex-end" alignItems="center">
              <Button mr={5} variant="link" onClick={onForgetPasswordClick}>
                忘記密碼？
              </Button>
              <Button
                onClick={handleSubmit}
                disabled={submitting}
                type="submit"
                variant="primary"
                size="large"
              >
                登入
              </Button>
            </Flex>
          </>
        )}
      />
      <Flex mt="auto" justifyContent="center">
        <InfoBoxButton onClick={onSignupClick}>
          <Link>還沒有帳號嗎？點我註冊</Link>
        </InfoBoxButton>
      </Flex>
    </FormWrapper>
  );
};
